module.exports = __webpack_public_path__ + "img/yzc-icon.da29b05f.png";